import { useTranslation } from '@frontend/i18n';
import { useSettingsNavigate } from '@frontend/settings-routing';
import { theme } from '@frontend/theme';
import { Button, Text } from '@frontend/design-system';
import { NoProvidersIllustration } from '../../images';
import { emptyStateContainerStyles } from './styles';

export const NoProvidersMessage = () => {
  const { t } = useTranslation('schedule');
  const { navigate } = useSettingsNavigate();

  const handleNavigation = () => {
    navigate({ to: '/schedule/manage-providers' });
  };

  return (
    <section css={emptyStateContainerStyles}>
      <NoProvidersIllustration />
      <Text color='light' textAlign='center' css={{ marginTop: theme.spacing(2) }}>
        {t('Your calendar is looking a bit empty!')}
        <br />
        {t('Click here to add your first provider and start booking appointments.')}
      </Text>
      <Button onClick={handleNavigation} iconName='plus'>
        {t('Add Provider')}
      </Button>
    </section>
  );
};
